var map = {
	"./official/bmr/apprentice.webp": 3753,
	"./official/bmr/apprentice_e.webp": 44909,
	"./official/bmr/apprentice_g.webp": 5667,
	"./official/bmr/assassin_e.webp": 17783,
	"./official/bmr/assassin_g.webp": 73265,
	"./official/bmr/bishop.webp": 42239,
	"./official/bmr/bishop_e.webp": 32799,
	"./official/bmr/bishop_g.webp": 5369,
	"./official/bmr/chambermaid_e.webp": 34467,
	"./official/bmr/chambermaid_g.webp": 75437,
	"./official/bmr/courtier_e.webp": 65515,
	"./official/bmr/courtier_g.webp": 18037,
	"./official/bmr/devilsadvocate_e.webp": 32988,
	"./official/bmr/devilsadvocate_g.webp": 48990,
	"./official/bmr/exorcist_e.webp": 71069,
	"./official/bmr/exorcist_g.webp": 72851,
	"./official/bmr/fool_e.webp": 40578,
	"./official/bmr/fool_g.webp": 17824,
	"./official/bmr/gambler_e.webp": 5120,
	"./official/bmr/gambler_g.webp": 23266,
	"./official/bmr/godfather_e.webp": 3442,
	"./official/bmr/godfather_g.webp": 11952,
	"./official/bmr/goon_e.webp": 39225,
	"./official/bmr/goon_g.webp": 66655,
	"./official/bmr/gossip_e.webp": 66335,
	"./official/bmr/gossip_g.webp": 19129,
	"./official/bmr/grandmother_e.webp": 61659,
	"./official/bmr/grandmother_g.webp": 3461,
	"./official/bmr/innkeeper_e.webp": 31203,
	"./official/bmr/innkeeper_g.webp": 70445,
	"./official/bmr/judge.webp": 12665,
	"./official/bmr/judge_e.webp": 34845,
	"./official/bmr/judge_g.webp": 62803,
	"./official/bmr/lunatic_e.webp": 73804,
	"./official/bmr/lunatic_g.webp": 72046,
	"./official/bmr/mastermind_e.webp": 37448,
	"./official/bmr/mastermind_g.webp": 39050,
	"./official/bmr/matron.webp": 14111,
	"./official/bmr/matron_e.webp": 83167,
	"./official/bmr/matron_g.webp": 35961,
	"./official/bmr/minstrel_e.webp": 57488,
	"./official/bmr/minstrel_g.webp": 6226,
	"./official/bmr/moonchild_e.webp": 95927,
	"./official/bmr/moonchild_g.webp": 89329,
	"./official/bmr/pacifist_e.webp": 47803,
	"./official/bmr/pacifist_g.webp": 73253,
	"./official/bmr/po_e.webp": 17051,
	"./official/bmr/po_g.webp": 1701,
	"./official/bmr/professor_e.webp": 73083,
	"./official/bmr/professor_g.webp": 41381,
	"./official/bmr/pukka_e.webp": 55674,
	"./official/bmr/pukka_g.webp": 23320,
	"./official/bmr/sailor_e.webp": 2698,
	"./official/bmr/sailor_g.webp": 47176,
	"./official/bmr/shabaloth_e.webp": 43584,
	"./official/bmr/shabaloth_g.webp": 13314,
	"./official/bmr/tealady_e.webp": 89668,
	"./official/bmr/tealady_g.webp": 38086,
	"./official/bmr/tinker_e.webp": 43269,
	"./official/bmr/tinker_g.webp": 1691,
	"./official/bmr/voudon.webp": 5829,
	"./official/bmr/voudon_e.webp": 86409,
	"./official/bmr/voudon_g.webp": 83375,
	"./official/bmr/zombuul_e.webp": 41104,
	"./official/bmr/zombuul_g.webp": 59218,
	"./official/carousel/acrobat_e.webp": 7303,
	"./official/carousel/acrobat_g.webp": 77793,
	"./official/carousel/alchemist_e.webp": 93297,
	"./official/carousel/alchemist_g.webp": 57047,
	"./official/carousel/alhadikhia_e.webp": 63271,
	"./official/carousel/alhadikhia_g.webp": 90689,
	"./official/carousel/alsaahir_e.webp": 82560,
	"./official/carousel/alsaahir_g.webp": 84354,
	"./official/carousel/amnesiac_e.webp": 12636,
	"./official/carousel/amnesiac_g.webp": 17022,
	"./official/carousel/atheist_e.webp": 15783,
	"./official/carousel/atheist_g.webp": 86273,
	"./official/carousel/balloonist_e.webp": 64406,
	"./official/carousel/balloonist_g.webp": 5172,
	"./official/carousel/banshee_e.webp": 25049,
	"./official/carousel/banshee_g.webp": 61311,
	"./official/carousel/boffin_e.webp": 88723,
	"./official/carousel/boffin_g.webp": 5789,
	"./official/carousel/boomdandy_e.webp": 86660,
	"./official/carousel/boomdandy_g.webp": 58822,
	"./official/carousel/bountyhunter_e.webp": 2706,
	"./official/carousel/bountyhunter_g.webp": 11216,
	"./official/carousel/cacklejack.webp": 10485,
	"./official/carousel/cacklejack_e.webp": 25785,
	"./official/carousel/cacklejack_g.webp": 53215,
	"./official/carousel/cannibal_e.webp": 84485,
	"./official/carousel/cannibal_g.webp": 42683,
	"./official/carousel/choirboy_e.webp": 53880,
	"./official/carousel/choirboy_g.webp": 78778,
	"./official/carousel/cultleader_e.webp": 90014,
	"./official/carousel/cultleader_g.webp": 88412,
	"./official/carousel/damsel_e.webp": 33005,
	"./official/carousel/damsel_g.webp": 77411,
	"./official/carousel/deusexfiasco.webp": 61062,
	"./official/carousel/engineer_e.webp": 65442,
	"./official/carousel/engineer_g.webp": 95712,
	"./official/carousel/farmer_e.webp": 34144,
	"./official/carousel/farmer_g.webp": 30562,
	"./official/carousel/fearmonger_e.webp": 79113,
	"./official/carousel/fearmonger_g.webp": 41839,
	"./official/carousel/ferryman.webp": 15455,
	"./official/carousel/fisherman_e.webp": 39418,
	"./official/carousel/fisherman_g.webp": 7064,
	"./official/carousel/gangster.webp": 77116,
	"./official/carousel/gangster_e.webp": 42148,
	"./official/carousel/gangster_g.webp": 90566,
	"./official/carousel/general_e.webp": 8893,
	"./official/carousel/general_g.webp": 91827,
	"./official/carousel/gnome.webp": 95005,
	"./official/carousel/gnome_e.webp": 51665,
	"./official/carousel/gnome_g.webp": 58263,
	"./official/carousel/goblin_e.webp": 51064,
	"./official/carousel/goblin_g.webp": 92314,
	"./official/carousel/golem_e.webp": 30093,
	"./official/carousel/golem_g.webp": 89123,
	"./official/carousel/harpy_e.webp": 42053,
	"./official/carousel/harpy_g.webp": 251,
	"./official/carousel/hatter_e.webp": 86179,
	"./official/carousel/hatter_g.webp": 76845,
	"./official/carousel/heretic_e.webp": 31491,
	"./official/carousel/heretic_g.webp": 87085,
	"./official/carousel/hermit_e.webp": 57524,
	"./official/carousel/hermit_g.webp": 7862,
	"./official/carousel/highpriestess_e.webp": 54877,
	"./official/carousel/highpriestess_g.webp": 37811,
	"./official/carousel/huntsman_e.webp": 33541,
	"./official/carousel/huntsman_g.webp": 91963,
	"./official/carousel/kazali_e.webp": 85281,
	"./official/carousel/kazali_g.webp": 74215,
	"./official/carousel/king_e.webp": 89652,
	"./official/carousel/king_g.webp": 22262,
	"./official/carousel/knight_e.webp": 66322,
	"./official/carousel/knight_g.webp": 17584,
	"./official/carousel/legion_e.webp": 50657,
	"./official/carousel/legion_g.webp": 23239,
	"./official/carousel/leviathan_e.webp": 63407,
	"./official/carousel/leviathan_g.webp": 43209,
	"./official/carousel/lilmonsta_e.webp": 35384,
	"./official/carousel/lilmonsta_g.webp": 51386,
	"./official/carousel/lleech_e.webp": 39250,
	"./official/carousel/lleech_g.webp": 47760,
	"./official/carousel/lordoftyphon_e.webp": 89063,
	"./official/carousel/lordoftyphon_g.webp": 16481,
	"./official/carousel/lycanthrope_e.webp": 37354,
	"./official/carousel/lycanthrope_g.webp": 19400,
	"./official/carousel/magician_e.webp": 38738,
	"./official/carousel/magician_g.webp": 73648,
	"./official/carousel/marionette_e.webp": 37127,
	"./official/carousel/marionette_g.webp": 64545,
	"./official/carousel/mezepheles_e.webp": 51241,
	"./official/carousel/mezepheles_g.webp": 31855,
	"./official/carousel/nightwatchman_e.webp": 92474,
	"./official/carousel/nightwatchman_g.webp": 76472,
	"./official/carousel/noble_e.webp": 41261,
	"./official/carousel/noble_g.webp": 76995,
	"./official/carousel/ogre_e.webp": 72152,
	"./official/carousel/ogre_g.webp": 97050,
	"./official/carousel/ojo_e.webp": 97059,
	"./official/carousel/ojo_g.webp": 52653,
	"./official/carousel/organgrinder_e.webp": 63577,
	"./official/carousel/organgrinder_g.webp": 62143,
	"./official/carousel/pixie_e.webp": 83230,
	"./official/carousel/pixie_g.webp": 14588,
	"./official/carousel/plaguedoctor_e.webp": 44826,
	"./official/carousel/plaguedoctor_g.webp": 12472,
	"./official/carousel/politician_e.webp": 92277,
	"./official/carousel/politician_g.webp": 77163,
	"./official/carousel/poppygrower_e.webp": 85613,
	"./official/carousel/poppygrower_g.webp": 46371,
	"./official/carousel/preacher_e.webp": 63095,
	"./official/carousel/preacher_g.webp": 2449,
	"./official/carousel/princess_e.webp": 40500,
	"./official/carousel/princess_g.webp": 42486,
	"./official/carousel/psychopath_e.webp": 17536,
	"./official/carousel/psychopath_g.webp": 97602,
	"./official/carousel/puzzlemaster_e.webp": 71301,
	"./official/carousel/puzzlemaster_g.webp": 86651,
	"./official/carousel/riot_e.webp": 3569,
	"./official/carousel/riot_g.webp": 47863,
	"./official/carousel/shugenja_e.webp": 70002,
	"./official/carousel/shugenja_g.webp": 78512,
	"./official/carousel/snitch_e.webp": 78824,
	"./official/carousel/snitch_g.webp": 96778,
	"./official/carousel/steward_e.webp": 90045,
	"./official/carousel/steward_g.webp": 14208,
	"./official/carousel/summoner_e.webp": 9255,
	"./official/carousel/summoner_g.webp": 79745,
	"./official/carousel/villageidiot_e.webp": 1268,
	"./official/carousel/villageidiot_g.webp": 67958,
	"./official/carousel/vizier_e.webp": 43172,
	"./official/carousel/vizier_g.webp": 15014,
	"./official/carousel/widow_e.webp": 72379,
	"./official/carousel/widow_g.webp": 14181,
	"./official/carousel/wizard_e.webp": 77056,
	"./official/carousel/wizard_g.webp": 57122,
	"./official/carousel/wraith_e.webp": 1584,
	"./official/carousel/wraith_g.webp": 93074,
	"./official/carousel/xaan_e.webp": 73195,
	"./official/carousel/xaan_g.webp": 25717,
	"./official/carousel/yaggababble_e.webp": 37008,
	"./official/carousel/yaggababble_g.webp": 2098,
	"./official/carousel/zealot_e.webp": 40528,
	"./official/carousel/zealot_g.webp": 32018,
	"./official/fabled/angel.webp": 11036,
	"./official/fabled/buddhist.webp": 63222,
	"./official/fabled/djinn.webp": 35640,
	"./official/fabled/doomsayer.webp": 12962,
	"./official/fabled/duchess.webp": 47088,
	"./official/fabled/fibbin.webp": 48045,
	"./official/fabled/fiddler.webp": 94137,
	"./official/fabled/hellslibrarian.webp": 26311,
	"./official/fabled/revolutionary.webp": 90002,
	"./official/fabled/sentinel.webp": 33295,
	"./official/fabled/spiritofivory.webp": 30736,
	"./official/fabled/toymaker.webp": 21439,
	"./official/generic/custom.webp": 20793,
	"./official/generic/custom_e.webp": 46525,
	"./official/generic/custom_g.webp": 29459,
	"./official/generic/demon.webp": 7857,
	"./official/generic/demon_e.webp": 87557,
	"./official/generic/demon_g.webp": 45979,
	"./official/generic/evil.webp": 30456,
	"./official/generic/fabled.webp": 96444,
	"./official/generic/good.webp": 60247,
	"./official/generic/loric.webp": 68999,
	"./official/generic/minion.webp": 82324,
	"./official/generic/minion_e.webp": 92332,
	"./official/generic/minion_g.webp": 90574,
	"./official/generic/outsider.webp": 74525,
	"./official/generic/outsider_e.webp": 785,
	"./official/generic/outsider_g.webp": 7383,
	"./official/generic/townsfolk.webp": 47053,
	"./official/generic/townsfolk_e.webp": 74369,
	"./official/generic/townsfolk_g.webp": 3879,
	"./official/generic/traveller.webp": 65097,
	"./official/generic/traveller_e.webp": 53709,
	"./official/generic/traveller_g.webp": 14467,
	"./official/loric/bigwig.webp": 83497,
	"./official/loric/bootlegger.webp": 63820,
	"./official/loric/gardener.webp": 16332,
	"./official/loric/godofug.webp": 60665,
	"./official/loric/hindu.webp": 22682,
	"./official/loric/knaves.webp": 84072,
	"./official/loric/pope.webp": 25012,
	"./official/loric/stormcatcher.webp": 56365,
	"./official/loric/tor.webp": 88975,
	"./official/loric/ventriloquist.webp": 62873,
	"./official/loric/zenomancer.webp": 14430,
	"./official/snv/artist_e.webp": 39653,
	"./official/snv/artist_g.webp": 98075,
	"./official/snv/barber_e.webp": 76960,
	"./official/snv/barber_g.webp": 78754,
	"./official/snv/barista.webp": 66760,
	"./official/snv/barista_e.webp": 2464,
	"./official/snv/barista_g.webp": 82530,
	"./official/snv/bonecollector.webp": 891,
	"./official/snv/bonecollector_e.webp": 50539,
	"./official/snv/bonecollector_g.webp": 3061,
	"./official/snv/butcher.webp": 60969,
	"./official/snv/butcher_e.webp": 84013,
	"./official/snv/butcher_g.webp": 36099,
	"./official/snv/cerenovus_e.webp": 22142,
	"./official/snv/cerenovus_g.webp": 53500,
	"./official/snv/clockmaker_e.webp": 5132,
	"./official/snv/clockmaker_g.webp": 3054,
	"./official/snv/deviant.webp": 66829,
	"./official/snv/deviant_e.webp": 63841,
	"./official/snv/deviant_g.webp": 78951,
	"./official/snv/dreamer_e.webp": 85814,
	"./official/snv/dreamer_g.webp": 53204,
	"./official/snv/eviltwin_e.webp": 15750,
	"./official/snv/eviltwin_g.webp": 67332,
	"./official/snv/fanggu_e.webp": 27852,
	"./official/snv/fanggu_g.webp": 26094,
	"./official/snv/flowergirl_e.webp": 47479,
	"./official/snv/flowergirl_g.webp": 40881,
	"./official/snv/harlot.webp": 42616,
	"./official/snv/harlot_e.webp": 37520,
	"./official/snv/harlot_g.webp": 29010,
	"./official/snv/juggler_e.webp": 36272,
	"./official/snv/juggler_g.webp": 85010,
	"./official/snv/klutz_e.webp": 20386,
	"./official/snv/klutz_g.webp": 50656,
	"./official/snv/mathematician_e.webp": 69645,
	"./official/snv/mathematician_g.webp": 21731,
	"./official/snv/mutant_e.webp": 67997,
	"./official/snv/mutant_g.webp": 50931,
	"./official/snv/nodashii_e.webp": 88627,
	"./official/snv/nodashii_g.webp": 44317,
	"./official/snv/oracle_e.webp": 17552,
	"./official/snv/oracle_g.webp": 82642,
	"./official/snv/philosopher_e.webp": 9845,
	"./official/snv/philosopher_g.webp": 94731,
	"./official/snv/pithag_e.webp": 60621,
	"./official/snv/pithag_g.webp": 12707,
	"./official/snv/sage_e.webp": 55410,
	"./official/snv/sage_g.webp": 6672,
	"./official/snv/savant_e.webp": 80633,
	"./official/snv/savant_g.webp": 8063,
	"./official/snv/seamstress_e.webp": 31968,
	"./official/snv/seamstress_g.webp": 50114,
	"./official/snv/snakecharmer_e.webp": 88082,
	"./official/snv/snakecharmer_g.webp": 69968,
	"./official/snv/sweetheart_e.webp": 55782,
	"./official/snv/sweetheart_g.webp": 83620,
	"./official/snv/towncrier_e.webp": 18985,
	"./official/snv/towncrier_g.webp": 15951,
	"./official/snv/vigormortis_e.webp": 50263,
	"./official/snv/vigormortis_g.webp": 5745,
	"./official/snv/vortox_e.webp": 97344,
	"./official/snv/vortox_g.webp": 15490,
	"./official/snv/witch_e.webp": 14385,
	"./official/snv/witch_g.webp": 58903,
	"./official/tb/baron_e.webp": 78905,
	"./official/tb/baron_g.webp": 77471,
	"./official/tb/beggar.webp": 127,
	"./official/tb/beggar_e.webp": 76127,
	"./official/tb/beggar_g.webp": 28921,
	"./official/tb/bureaucrat.webp": 86781,
	"./official/tb/bureaucrat_e.webp": 33041,
	"./official/tb/bureaucrat_g.webp": 93911,
	"./official/tb/butler_e.webp": 81649,
	"./official/tb/butler_g.webp": 88247,
	"./official/tb/chef_e.webp": 41639,
	"./official/tb/chef_g.webp": 8577,
	"./official/tb/drunk_e.webp": 80519,
	"./official/tb/drunk_g.webp": 91585,
	"./official/tb/empath_e.webp": 16666,
	"./official/tb/empath_g.webp": 53368,
	"./official/tb/fortuneteller_e.webp": 35316,
	"./official/tb/fortuneteller_g.webp": 85654,
	"./official/tb/gunslinger.webp": 70067,
	"./official/tb/gunslinger_e.webp": 23891,
	"./official/tb/gunslinger_g.webp": 40957,
	"./official/tb/imp_e.webp": 65519,
	"./official/tb/imp_g.webp": 84905,
	"./official/tb/investigator_e.webp": 22026,
	"./official/tb/investigator_g.webp": 10184,
	"./official/tb/librarian_e.webp": 91197,
	"./official/tb/librarian_g.webp": 35507,
	"./official/tb/mayor_e.webp": 18585,
	"./official/tb/mayor_g.webp": 54847,
	"./official/tb/monk_e.webp": 38900,
	"./official/tb/monk_g.webp": 5590,
	"./official/tb/poisoner_e.webp": 65016,
	"./official/tb/poisoner_g.webp": 28314,
	"./official/tb/ravenkeeper_e.webp": 52969,
	"./official/tb/ravenkeeper_g.webp": 15695,
	"./official/tb/recluse_e.webp": 72944,
	"./official/tb/recluse_g.webp": 74706,
	"./official/tb/saint_e.webp": 6000,
	"./official/tb/saint_g.webp": 97490,
	"./official/tb/scapegoat.webp": 47172,
	"./official/tb/scapegoat_e.webp": 79196,
	"./official/tb/scapegoat_g.webp": 95198,
	"./official/tb/scarletwoman_e.webp": 18883,
	"./official/tb/scarletwoman_g.webp": 74477,
	"./official/tb/slayer_e.webp": 67081,
	"./official/tb/slayer_g.webp": 29807,
	"./official/tb/soldier_e.webp": 65063,
	"./official/tb/soldier_g.webp": 49953,
	"./official/tb/spy_e.webp": 18175,
	"./official/tb/spy_g.webp": 90745,
	"./official/tb/thief.webp": 65590,
	"./official/tb/thief_e.webp": 77549,
	"./official/tb/thief_g.webp": 86883,
	"./official/tb/undertaker_e.webp": 74982,
	"./official/tb/undertaker_g.webp": 2820,
	"./official/tb/virgin_e.webp": 77498,
	"./official/tb/virgin_g.webp": 36248,
	"./official/tb/washerwoman_e.webp": 41047,
	"./official/tb/washerwoman_g.webp": 77297,
	"./unofficial/Alternate/acrobat.webp": 93080,
	"./unofficial/Alternate/alchemist.webp": 26134,
	"./unofficial/Alternate/alhadikhia.webp": 91830,
	"./unofficial/Alternate/alsaahir.webp": 27925,
	"./unofficial/Alternate/amnesiac.webp": 77653,
	"./unofficial/Alternate/apprentice_e.webp": 32001,
	"./unofficial/Alternate/apprentice_g.webp": 47111,
	"./unofficial/Alternate/artist.webp": 69981,
	"./unofficial/Alternate/assassin.webp": 99827,
	"./unofficial/Alternate/atheist.webp": 1472,
	"./unofficial/Alternate/balloonist.webp": 85447,
	"./unofficial/Alternate/banshee.webp": 34330,
	"./unofficial/Alternate/barber.webp": 32668,
	"./unofficial/Alternate/barista_e.webp": 12412,
	"./unofficial/Alternate/barista_g.webp": 97406,
	"./unofficial/Alternate/baron.webp": 42870,
	"./unofficial/Alternate/beggar_e.webp": 35054,
	"./unofficial/Alternate/beggar_g.webp": 53484,
	"./unofficial/Alternate/bishop_e.webp": 71675,
	"./unofficial/Alternate/bishop_g.webp": 41605,
	"./unofficial/Alternate/boffin.webp": 50278,
	"./unofficial/Alternate/bonecollector_e.webp": 47463,
	"./unofficial/Alternate/bonecollector_g.webp": 74881,
	"./unofficial/Alternate/boomdandy.webp": 43535,
	"./unofficial/Alternate/bountyhunter.webp": 37043,
	"./unofficial/Alternate/bureaucrat_e.webp": 81272,
	"./unofficial/Alternate/bureaucrat_g.webp": 44570,
	"./unofficial/Alternate/butcher_e.webp": 55705,
	"./unofficial/Alternate/butcher_g.webp": 2911,
	"./unofficial/Alternate/butler.webp": 45376,
	"./unofficial/Alternate/cacklejack_e.webp": 24420,
	"./unofficial/Alternate/cacklejack_g.webp": 30214,
	"./unofficial/Alternate/cannibal.webp": 92864,
	"./unofficial/Alternate/cerenovus.webp": 80886,
	"./unofficial/Alternate/chambermaid.webp": 93327,
	"./unofficial/Alternate/chef.webp": 51078,
	"./unofficial/Alternate/choirboy.webp": 97249,
	"./unofficial/Alternate/clockmaker.webp": 40992,
	"./unofficial/Alternate/courtier.webp": 39615,
	"./unofficial/Alternate/cultleader.webp": 55075,
	"./unofficial/Alternate/damsel.webp": 50352,
	"./unofficial/Alternate/demon.webp": 9089,
	"./unofficial/Alternate/deviant_e.webp": 30493,
	"./unofficial/Alternate/deviant_g.webp": 58451,
	"./unofficial/Alternate/devilsadvocate.webp": 84896,
	"./unofficial/Alternate/dreamer.webp": 93598,
	"./unofficial/Alternate/drunk.webp": 82388,
	"./unofficial/Alternate/empath.webp": 72531,
	"./unofficial/Alternate/engineer.webp": 57843,
	"./unofficial/Alternate/eviltwin.webp": 12742,
	"./unofficial/Alternate/exorcist.webp": 65429,
	"./unofficial/Alternate/fanggu.webp": 5016,
	"./unofficial/Alternate/farmer.webp": 43249,
	"./unofficial/Alternate/fearmonger.webp": 61996,
	"./unofficial/Alternate/fisherman.webp": 36821,
	"./unofficial/Alternate/flowergirl.webp": 42235,
	"./unofficial/Alternate/fool.webp": 2346,
	"./unofficial/Alternate/fortuneteller.webp": 21727,
	"./unofficial/Alternate/gambler.webp": 28324,
	"./unofficial/Alternate/gangster_e.webp": 8373,
	"./unofficial/Alternate/gangster_g.webp": 55851,
	"./unofficial/Alternate/general.webp": 69098,
	"./unofficial/Alternate/gnome_e.webp": 42886,
	"./unofficial/Alternate/gnome_g.webp": 71044,
	"./unofficial/Alternate/goblin.webp": 95137,
	"./unofficial/Alternate/godfather.webp": 31842,
	"./unofficial/Alternate/golem.webp": 64938,
	"./unofficial/Alternate/goon.webp": 11001,
	"./unofficial/Alternate/gossip.webp": 38947,
	"./unofficial/Alternate/grandmother.webp": 50511,
	"./unofficial/Alternate/gunslinger_e.webp": 15262,
	"./unofficial/Alternate/gunslinger_g.webp": 82908,
	"./unofficial/Alternate/harlot_e.webp": 57348,
	"./unofficial/Alternate/harlot_g.webp": 29510,
	"./unofficial/Alternate/harpy.webp": 18842,
	"./unofficial/Alternate/hatter.webp": 29238,
	"./unofficial/Alternate/heretic.webp": 82676,
	"./unofficial/Alternate/hermit.webp": 93249,
	"./unofficial/Alternate/highpriestess.webp": 6730,
	"./unofficial/Alternate/huntsman.webp": 40864,
	"./unofficial/Alternate/imp.webp": 93024,
	"./unofficial/Alternate/innkeeper.webp": 92487,
	"./unofficial/Alternate/investigator.webp": 13479,
	"./unofficial/Alternate/judge_e.webp": 47801,
	"./unofficial/Alternate/judge_g.webp": 46367,
	"./unofficial/Alternate/juggler.webp": 10372,
	"./unofficial/Alternate/kazali.webp": 63332,
	"./unofficial/Alternate/king.webp": 32517,
	"./unofficial/Alternate/klutz.webp": 99346,
	"./unofficial/Alternate/knight.webp": 92415,
	"./unofficial/Alternate/legion.webp": 81292,
	"./unofficial/Alternate/leviathan.webp": 30512,
	"./unofficial/Alternate/librarian.webp": 5038,
	"./unofficial/Alternate/lilmonsta.webp": 88911,
	"./unofficial/Alternate/lleech.webp": 78079,
	"./unofficial/Alternate/lordoftyphon.webp": 23462,
	"./unofficial/Alternate/lunatic.webp": 75264,
	"./unofficial/Alternate/lycanthrope.webp": 76653,
	"./unofficial/Alternate/magician.webp": 83883,
	"./unofficial/Alternate/marionette.webp": 83258,
	"./unofficial/Alternate/mastermind.webp": 4596,
	"./unofficial/Alternate/mathematician.webp": 30221,
	"./unofficial/Alternate/matron_e.webp": 66707,
	"./unofficial/Alternate/matron_g.webp": 83773,
	"./unofficial/Alternate/mayor.webp": 12630,
	"./unofficial/Alternate/mezepheles.webp": 52208,
	"./unofficial/Alternate/minion.webp": 98692,
	"./unofficial/Alternate/minstrel.webp": 5588,
	"./unofficial/Alternate/monk.webp": 33817,
	"./unofficial/Alternate/moonchild.webp": 23331,
	"./unofficial/Alternate/mutant.webp": 92925,
	"./unofficial/Alternate/nightwatchman.webp": 71993,
	"./unofficial/Alternate/noble.webp": 34390,
	"./unofficial/Alternate/nodashii.webp": 57447,
	"./unofficial/Alternate/ogre.webp": 27513,
	"./unofficial/Alternate/ojo.webp": 62212,
	"./unofficial/Alternate/oracle.webp": 96044,
	"./unofficial/Alternate/organgrinder.webp": 92296,
	"./unofficial/Alternate/outsider.webp": 44877,
	"./unofficial/Alternate/pacifist.webp": 70991,
	"./unofficial/Alternate/philosopher.webp": 7045,
	"./unofficial/Alternate/pithag.webp": 27301,
	"./unofficial/Alternate/pixie.webp": 76157,
	"./unofficial/Alternate/plaguedoctor.webp": 93795,
	"./unofficial/Alternate/po.webp": 12151,
	"./unofficial/Alternate/poisoner.webp": 49893,
	"./unofficial/Alternate/politician.webp": 20388,
	"./unofficial/Alternate/poppygrower.webp": 29370,
	"./unofficial/Alternate/preacher.webp": 34966,
	"./unofficial/Alternate/princess.webp": 29373,
	"./unofficial/Alternate/professor.webp": 2743,
	"./unofficial/Alternate/psychopath.webp": 46377,
	"./unofficial/Alternate/pukka.webp": 44386,
	"./unofficial/Alternate/puzzlemaster.webp": 89912,
	"./unofficial/Alternate/ravenkeeper.webp": 85722,
	"./unofficial/Alternate/recluse.webp": 59079,
	"./unofficial/Alternate/riot.webp": 33284,
	"./unofficial/Alternate/sage.webp": 79602,
	"./unofficial/Alternate/sailor.webp": 32146,
	"./unofficial/Alternate/saint.webp": 34139,
	"./unofficial/Alternate/savant.webp": 49657,
	"./unofficial/Alternate/scapegoat_e.webp": 58859,
	"./unofficial/Alternate/scapegoat_g.webp": 59573,
	"./unofficial/Alternate/scarletwoman.webp": 32454,
	"./unofficial/Alternate/seamstress.webp": 29156,
	"./unofficial/Alternate/shabaloth.webp": 84300,
	"./unofficial/Alternate/shugenja.webp": 49651,
	"./unofficial/Alternate/slayer.webp": 65184,
	"./unofficial/Alternate/snakecharmer.webp": 41122,
	"./unofficial/Alternate/snitch.webp": 85529,
	"./unofficial/Alternate/soldier.webp": 28080,
	"./unofficial/Alternate/spy.webp": 58156,
	"./unofficial/Alternate/steward.webp": 46138,
	"./unofficial/Alternate/summoner.webp": 34741,
	"./unofficial/Alternate/sweetheart.webp": 38966,
	"./unofficial/Alternate/tealady.webp": 78888,
	"./unofficial/Alternate/thief_e.webp": 22942,
	"./unofficial/Alternate/thief_g.webp": 90588,
	"./unofficial/Alternate/tinker.webp": 59117,
	"./unofficial/Alternate/towncrier.webp": 12945,
	"./unofficial/Alternate/townsfolk.webp": 18653,
	"./unofficial/Alternate/traveller_e.webp": 76669,
	"./unofficial/Alternate/traveller_g.webp": 59603,
	"./unofficial/Alternate/undertaker.webp": 82691,
	"./unofficial/Alternate/vigormortis.webp": 3435,
	"./unofficial/Alternate/villageidiot.webp": 32421,
	"./unofficial/Alternate/virgin.webp": 31363,
	"./unofficial/Alternate/vizier.webp": 96973,
	"./unofficial/Alternate/vortox.webp": 91988,
	"./unofficial/Alternate/voudon_e.webp": 68221,
	"./unofficial/Alternate/voudon_g.webp": 96179,
	"./unofficial/Alternate/washerwoman.webp": 24968,
	"./unofficial/Alternate/widow.webp": 13020,
	"./unofficial/Alternate/witch.webp": 56257,
	"./unofficial/Alternate/wizard.webp": 14325,
	"./unofficial/Alternate/wraith.webp": 48269,
	"./unofficial/Alternate/xaan.webp": 3030,
	"./unofficial/Alternate/yaggababble.webp": 27735,
	"./unofficial/Alternate/zealot.webp": 58593,
	"./unofficial/Alternate/zombuul.webp": 50284,
	"./unofficial/acrobat.webp": 83261,
	"./unofficial/alchemist.webp": 61387,
	"./unofficial/alhadikhia.webp": 45549,
	"./unofficial/alsaahir.webp": 42930,
	"./unofficial/amnesiac.webp": 77418,
	"./unofficial/angel.webp": 5374,
	"./unofficial/apprentice.webp": 45974,
	"./unofficial/artist.webp": 54306,
	"./unofficial/assassin.webp": 20524,
	"./unofficial/atheist.webp": 63433,
	"./unofficial/balloonist.webp": 50120,
	"./unofficial/banshee.webp": 69967,
	"./unofficial/barber.webp": 77271,
	"./unofficial/barista.webp": 71377,
	"./unofficial/baron.webp": 17251,
	"./unofficial/beggar.webp": 8113,
	"./unofficial/bigwig.webp": 6830,
	"./unofficial/bishop.webp": 54328,
	"./unofficial/boffin.webp": 46457,
	"./unofficial/bonecollector.webp": 17814,
	"./unofficial/boomdandy.webp": 91698,
	"./unofficial/bootlegger.webp": 32727,
	"./unofficial/bountyhunter.webp": 44268,
	"./unofficial/buddhist.webp": 45316,
	"./unofficial/bureaucrat.webp": 60671,
	"./unofficial/butcher.webp": 73572,
	"./unofficial/butler.webp": 25655,
	"./unofficial/cacklejack.webp": 49703,
	"./unofficial/cannibal.webp": 18611,
	"./unofficial/cerenovus.webp": 87483,
	"./unofficial/chambermaid.webp": 90598,
	"./unofficial/chef.webp": 37977,
	"./unofficial/choirboy.webp": 88934,
	"./unofficial/clockmaker.webp": 81151,
	"./unofficial/courtier.webp": 14904,
	"./unofficial/cultleader.webp": 96484,
	"./unofficial/custom.webp": 25458,
	"./unofficial/damsel.webp": 27343,
	"./unofficial/demon.webp": 58944,
	"./unofficial/deusexfiasco.webp": 62412,
	"./unofficial/deviant.webp": 75712,
	"./unofficial/devilsadvocate.webp": 6955,
	"./unofficial/djinn.webp": 80702,
	"./unofficial/doomsayer.webp": 99796,
	"./unofficial/dreamer.webp": 8699,
	"./unofficial/drunk.webp": 15185,
	"./unofficial/duchess.webp": 22790,
	"./unofficial/empath.webp": 52560,
	"./unofficial/engineer.webp": 65280,
	"./unofficial/evil.webp": 22271,
	"./unofficial/eviltwin.webp": 27961,
	"./unofficial/exorcist.webp": 29442,
	"./unofficial/fabled.webp": 41783,
	"./unofficial/fanggu.webp": 11631,
	"./unofficial/farmer.webp": 1958,
	"./unofficial/fearmonger.webp": 88111,
	"./unofficial/ferryman.webp": 76585,
	"./unofficial/fibbin.webp": 95163,
	"./unofficial/fiddler.webp": 22195,
	"./unofficial/fisherman.webp": 65420,
	"./unofficial/flowergirl.webp": 23768,
	"./unofficial/fool.webp": 47709,
	"./unofficial/fortuneteller.webp": 77254,
	"./unofficial/gambler.webp": 64725,
	"./unofficial/gangster.webp": 1282,
	"./unofficial/gardener.webp": 13299,
	"./unofficial/general.webp": 8307,
	"./unofficial/gnome.webp": 74967,
	"./unofficial/goblin.webp": 24962,
	"./unofficial/godfather.webp": 64651,
	"./unofficial/godofug.webp": 92032,
	"./unofficial/golem.webp": 73031,
	"./unofficial/good.webp": 45200,
	"./unofficial/goon.webp": 85562,
	"./unofficial/gossip.webp": 68288,
	"./unofficial/grandmother.webp": 20094,
	"./unofficial/gunslinger.webp": 55013,
	"./unofficial/harlot.webp": 19879,
	"./unofficial/harpy.webp": 13547,
	"./unofficial/hatter.webp": 64625,
	"./unofficial/hellslibrarian.webp": 97521,
	"./unofficial/heretic.webp": 85233,
	"./unofficial/hermit.webp": 3226,
	"./unofficial/highpriestess.webp": 16563,
	"./unofficial/hindu.webp": 25975,
	"./unofficial/huntsman.webp": 22999,
	"./unofficial/imp.webp": 66381,
	"./unofficial/innkeeper.webp": 31830,
	"./unofficial/investigator.webp": 74768,
	"./unofficial/judge.webp": 35356,
	"./unofficial/juggler.webp": 37597,
	"./unofficial/kazali.webp": 38991,
	"./unofficial/king.webp": 11786,
	"./unofficial/klutz.webp": 98339,
	"./unofficial/knaves.webp": 43491,
	"./unofficial/knight.webp": 68980,
	"./unofficial/legion.webp": 37059,
	"./unofficial/leviathan.webp": 65797,
	"./unofficial/librarian.webp": 8207,
	"./unofficial/lilmonsta.webp": 50322,
	"./unofficial/lleech.webp": 13108,
	"./unofficial/lordoftyphon.webp": 4801,
	"./unofficial/loric.webp": 47898,
	"./unofficial/lunatic.webp": 74813,
	"./unofficial/lycanthrope.webp": 54940,
	"./unofficial/magician.webp": 32244,
	"./unofficial/marionette.webp": 12581,
	"./unofficial/mastermind.webp": 29755,
	"./unofficial/mathematician.webp": 21748,
	"./unofficial/matron.webp": 4976,
	"./unofficial/mayor.webp": 31883,
	"./unofficial/mezepheles.webp": 95167,
	"./unofficial/minion.webp": 75595,
	"./unofficial/minstrel.webp": 41695,
	"./unofficial/monk.webp": 37594,
	"./unofficial/moonchild.webp": 8642,
	"./unofficial/mutant.webp": 77366,
	"./unofficial/nightwatchman.webp": 76992,
	"./unofficial/noble.webp": 72651,
	"./unofficial/nodashii.webp": 33936,
	"./unofficial/ogre.webp": 88542,
	"./unofficial/ojo.webp": 5389,
	"./unofficial/oracle.webp": 96207,
	"./unofficial/organgrinder.webp": 38999,
	"./unofficial/outsider.webp": 47046,
	"./unofficial/pacifist.webp": 12356,
	"./unofficial/philosopher.webp": 74356,
	"./unofficial/pithag.webp": 90578,
	"./unofficial/pixie.webp": 99960,
	"./unofficial/plaguedoctor.webp": 10916,
	"./unofficial/po.webp": 84016,
	"./unofficial/poisoner.webp": 80598,
	"./unofficial/politician.webp": 52823,
	"./unofficial/pope.webp": 32543,
	"./unofficial/poppygrower.webp": 63671,
	"./unofficial/preacher.webp": 82661,
	"./unofficial/princess.webp": 90106,
	"./unofficial/professor.webp": 46974,
	"./unofficial/psychopath.webp": 63406,
	"./unofficial/pukka.webp": 39239,
	"./unofficial/puzzlemaster.webp": 90339,
	"./unofficial/ravenkeeper.webp": 87039,
	"./unofficial/recluse.webp": 52162,
	"./unofficial/revolutionary.webp": 83204,
	"./unofficial/riot.webp": 68191,
	"./unofficial/sage.webp": 43969,
	"./unofficial/sailor.webp": 4133,
	"./unofficial/saint.webp": 49246,
	"./unofficial/savant.webp": 79274,
	"./unofficial/scapegoat.webp": 25130,
	"./unofficial/scarletwoman.webp": 47341,
	"./unofficial/seamstress.webp": 42915,
	"./unofficial/sentinel.webp": 49169,
	"./unofficial/shabaloth.webp": 53453,
	"./unofficial/shugenja.webp": 73192,
	"./unofficial/slayer.webp": 90991,
	"./unofficial/snakecharmer.webp": 8929,
	"./unofficial/snitch.webp": 63390,
	"./unofficial/soldier.webp": 61345,
	"./unofficial/spiritofivory.webp": 50110,
	"./unofficial/spy.webp": 29945,
	"./unofficial/steward.webp": 67587,
	"./unofficial/stormcatcher.webp": 45926,
	"./unofficial/summoner.webp": 50593,
	"./unofficial/sweetheart.webp": 38553,
	"./unofficial/tealady.webp": 27837,
	"./unofficial/thief.webp": 59099,
	"./unofficial/tinker.webp": 76654,
	"./unofficial/tor.webp": 82822,
	"./unofficial/towncrier.webp": 55648,
	"./unofficial/townsfolk.webp": 47436,
	"./unofficial/toymaker.webp": 3465,
	"./unofficial/traveller.webp": 53020,
	"./unofficial/undertaker.webp": 32804,
	"./unofficial/ventriloquist.webp": 4944,
	"./unofficial/vigormortis.webp": 67978,
	"./unofficial/villageidiot.webp": 49826,
	"./unofficial/virgin.webp": 77504,
	"./unofficial/vizier.webp": 30378,
	"./unofficial/vortox.webp": 23627,
	"./unofficial/voudon.webp": 11234,
	"./unofficial/washerwoman.webp": 47797,
	"./unofficial/widow.webp": 78533,
	"./unofficial/witch.webp": 4544,
	"./unofficial/wizard.webp": 27670,
	"./unofficial/wraith.webp": 38090,
	"./unofficial/xaan.webp": 46209,
	"./unofficial/yaggababble.webp": 53050,
	"./unofficial/zealot.webp": 96514,
	"./unofficial/zenomancer.webp": 77973,
	"./unofficial/zombuul.webp": 76369
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55457;